import { render } from "./UXFolioLogo.vue?vue&type=template&id=24c9b9f2&scoped=true"
import script from "./UXFolioLogo.vue?vue&type=script&lang=js"
export * from "./UXFolioLogo.vue?vue&type=script&lang=js"

import "./UXFolioLogo.vue?vue&type=style&index=0&id=24c9b9f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c9b9f2"],['__file',"src/scripts/view/components/UXFolioLogo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24c9b9f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24c9b9f2', __exports__)) {
    api.reload('24c9b9f2', __exports__)
  }
  
  module.hot.accept("./UXFolioLogo.vue?vue&type=template&id=24c9b9f2&scoped=true", () => {
    api.rerender('24c9b9f2', render)
  })

}


export default __exports__